module.exports = __webpack_public_path__ + "static/img/lang-toggle.59e8917d.png";